<template>
  <div class="yxtbiz-kng-audit-content standard-size-14" v-loading="loading">
    <template v-if="courseDelete">
      <div class="standard-size-16 yxt-weight-5">{{$t('pc_biz_kng_courseinfo'/** 课程信息 */)}}</div>
      <div class="color-gray-7 mt16">{{$t('pc_biz_kng_coursedelete'/** 课程已删除 */)}}</div>
    </template>
    <template v-else>
      <div class="yxtbiz-kng-audit-content__cover" v-if="coverUrl">
      <yxt-image :src="coverUrl" width="100%" height="100%" />
      <yxt-tag v-if="coverUrlIsChange" class="yxtbiz-kng-audit-content__cover-tag" type="warning" size="mini">{{$t('pc_biz_kng_lbl_hadchanged'/** 已更改 */)}}</yxt-tag>
    </div>
    <div v-for="(group, gIndex) in groupList" :key="gIndex" :class="gIndex>0 ? 'mt32' : ''">
      <div class="yxtbiz-kng-audit-content__title standard-size-16 yxt-weight-5">{{group.title}}</div>
      <div class="yxtbiz-kng-audit-content__line  standard-size-14" v-for="(item,index) in group.list" :class="index === 0 ? 'mt16' : 'mt12'" :key="item.label">
        <div class="yxtbiz-kng-audit-content__label" :class="labelWidthClass">{{item.label}}</div>
        <div class="yxtbiz-kng-audit-content__text">
          <text-node :config="item" @preview="previewCourse"></text-node>
        </div>
      </div>
    </div>
    </template>
  </div>
</template>

<script>
import TextNode from '../components/TextNode.vue';
import { getAuditKngInfo, getAttributeConfig, getKngType } from '../service';
import auditMixins from '../mixins';
import { FILE_TYPE_TO_ROUTE_PATH } from '../enum';
import commonUtil from 'yxt-biz-pc/packages/common-util';
export default {
  name: 'YxtbizKngAuditContent',
  name_zh: '课程审核内容',
  mixins: [auditMixins],
  components: {
    TextNode
  },
  props: {
    id: {
      type: String,
      required: true,
      desc: '知识id',
      setter: 'StringSetter'
    }
  },
  data() {
    return {
      loading: false,
      groupList: [],
      coverUrl: '',
      coverUrlIsChange: false,
      courseDelete: true
    };
  },
  computed: {
    labelWidthClass() {
      const isEnglish = commonUtil.getLanguage() === 'en';
      return isEnglish ? 'w132' : 'w68';
    }
  },
  watch: {
    id: {
      immediate: true,
      handler() {
        this.getInfo();
      }
    }
  },
  methods: {
    async getInfo() {
      this.courseDelete = false;
      this.loading = true;
      // 获取公共配置，获取自定义字段设置，获取课程审核详情
      Promise.all([this.initConfig(), this.getAuditKngInfo()])
        .then(async([, list]) => {
          this.groupList = list;
        }).finally(() => {
          this.loading = false;
        });
    },
    async getAuditKngInfo() {
      try {
        const res = await getAuditKngInfo(this.id);
        this.coverUrl = res.coverUrl;
        this.coverUrlIsChange = this.isValueChange('coverUrl', res);
        const config = await getAttributeConfig(res.draftId);
        const groupList = await this.getInfoShowData(res, config);
        return Promise.resolve(groupList);
      } catch (e) {
        if (e && e.error && e.error.key === 'apis.kng.knowledge.NotExist') {
          this.courseDelete = true;
        }
        return Promise.reject();
      }
    },
    previewCourse() {
      getKngType(this.id)
        .then(({ fileType }) => {
          const type = FILE_TYPE_TO_ROUTE_PATH[fileType];
          const id = type === 'course' ? '' : this.id;
          const courseId = type === 'course' ? this.id : '';
          const url = `/kng/#/${type}/preview/detail?id=${id}&courseId=${courseId}&previewType=1&audit=1`;
          window.open(url);
        });
    }
  }
};
</script>
